import React from 'react';
import { Modal, Button } from 'tea-component';

import './index.scss';
import { useIntl } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import RegionCountryItem from '@/pages/opinion/components/Snippets/RegionCountryItem';

// 编辑确认弹窗
export default function NewMediaPopup(props: any) {
  const { visible, confirm, close } = props;

  // 文章内容主体
  const { caption, title, content, time, channel, region } = props;

  const { formatMessage } = useIntl();

  return (
    <Modal
      className="feeds-mediapopup"
      visible={visible}
      caption={caption}
      onClose={() => {
        close();
      }}
    >
      <Modal.Body>
        <div className="feeds-mediapopup-hd">
          <div className="feeds-mediapopup-tit">{title}</div>
          <div className="feeds-mediapopup-info">
            <div className="feeds-mediapopup-text">{time}</div>
            <div className="feeds-mediapopup-text">
              <RegionCountryItem
                market={region}
                showText={false}
                className={`feeds-mediapopup-region ${region}`}
              ></RegionCountryItem>
              <SvgIcon
                type="appfamitsu-icon"
                className="feeds-mediapopup-icon"
              />
              {channel}
            </div>
          </div>
        </div>
        <div className="feeds-mediapopup-bd">
          <div className="feeds-mediapopup-content">{content}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            confirm?.();
          }}
        >
          {formatMessage({ id: 'Go to' })}
        </Button>
        <Button
          type="weak"
          onClick={() => {
            close?.();
          }}
        >
          {formatMessage({ id: 'Cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
